import { List, Map } from 'immutable'
import * as React from 'react'
import { AsyncState, any, fromJSX, loadedAsyncState, stateful } from 'widgets-for-react'
import { renderBlock } from '../../../Client/components/cms/blocks/block_to_widget.gen'
import { ImageSize } from '../../../Client/components/cms/blocks/types.gen'
import { ListWithAtLeast3Items } from '../../components/cms/blocks/widgets/imageGalleryBlock.gen'
import { GetCookiebarButton, GetCookiebarContent } from '../../components/drupal/rendering/cookiebar_utils.mod'
import { FeaturedContentBlock } from '../../components/publicSite/blocks/custom_blocks/widgets/featuredContent'
import { cardsBlock } from '../../components/publicSite/blocks/custom_blocks/widgets/cardsBlock.mod'
import { quoteBlock } from '../../components/publicSite/blocks/custom_blocks/widgets/quoteBlock.mod'
import {
  cardsBlockClasses,
  ctaBlockClasses,
  downloadBlockClasses,
  expandBlockClasses,
  imageGalleryBlockClasses,
  linkGridBlockClasses,
  linkGridBlockPlainClasses,
  linkListBlockClasses,
  mediaBlockClasses,
  mediaBlockNestedClasses,
  quoteBlockClasses,
  quoteBlockNestedClasses,
  textBlockClasses,
  textBlockNestedClasses,
} from '../../components/publicSite/blocks/style.mod'
import { CMSState } from '../../components/publicSite/drupalPage/state'
import {
  ctablock_src,
  ctablock_srcset,
  gallery_src,
  gallery_srcset,
  get_default_data_src,
  get_default_data_srcset,
  linkgridblock_src,
  linkgridblock_srcset,
  quoteblock_src,
  quoteblock_srcset,
} from '../../components/publicSite/utils/extra_images.mod'

export const FakeCMSState: CMSState = {
  images: Map<number, AsyncState<Map<ImageSize, string>>>()
    .set(
      2,
      loadedAsyncState(
        Map<ImageSize, string>()
          .set('640w', '/styleguide/images/640x360.png')
          .set('640x360', '/styleguide/images/640x360.png')
          .set('1280w', '/styleguide/images/1280x720.png')
          .set('1280x720', '/styleguide/images/1280x720.png')
          .set('1920w', '/styleguide/images/1920x1080.png')
          .set('2880w', '/styleguide/images/2880x1620.png')
      )
    )
    .set(
      3,
      loadedAsyncState(
        Map<ImageSize, string>()
          .set('640x360', '/styleguide/images/640x360-reverse.png')
          .set('1280x720', '/styleguide/images/1280x720.png')
          .set('700w', '/styleguide/images/640x360-reverse.png')
          .set('1400w', '/styleguide/images/1280x720.png')
          .set('2800w', '/styleguide/images/2880x1620.png')
      )
    )
    .set(
      4,
      loadedAsyncState(
        Map<ImageSize, string>()
          .set('640w', '/styleguide/images/640x960.png')
          .set('1280w', '/styleguide/images/1280x1920.png')
          .set('1920w', '/styleguide/images/1920x2880.png')
          .set('2880w', '/styleguide/images/2880x4320.png')
      )
    ),
  blocks: Map<any, any>().set(13, {
    kind: 'imageGalleryBlock',
    value: {
      0: {
        index: 13,
        title: (
          <>
            Etiam rhoncus <span className="weight--bold">Maecenas tempus.</span>
          </>
        ),
        intro:
          'Leo eget bibendum sodales, augue velit cursus nunc, quis gravida magna mi a libero. Fusce vulputate eleifend sapien. Vestibulum purus quam, scelerisque ut, mollis sed, nonummy id, metus. Nullam accumsan lorem in dui.',
        images: new ListWithAtLeast3Items(
          List([
            {
              index: 1301,
              image: 2,
              image_alt: 'Leo eget bibendum sodales',
              image_size: '1920w',
              is_foreground: false,
              caption: 'Fusce vulputate eleifend sapien.',
              source: 'John Doe'
            },
            {
              index: 1302,
              image: 4,
              image_alt: 'Leo eget bibendum sodales',
              image_size: '1920w',
              is_foreground: false,
              caption: 'Fusce vulputate eleifend sapien.',
              source: 'John Doe'
            },
            {
              index: 1303,
              image: 2,
              image_alt: 'Leo eget bibendum sodales',
              image_size: '1280w',
              is_foreground: false,
              caption: 'Fusce vulputate eleifend sapien.',
              source: 'John Doe'
            },
            {
              index: 1304,
              image: 2,
              image_alt: 'Leo eget bibendum sodales',
              image_size: '2880w',
              is_foreground: false,
              caption: 'Fusce vulputate eleifend sapien.',
              source: 'John Doe'
            },
            {
              index: 1305,
              image: 2,
              image_alt: 'Leo eget bibendum sodales',
              image_size: '1920w',
              is_foreground: false,
              caption: '',
              source: ''
            },
            {
              index: 1306,
              image: 2,
              image_alt: 'Leo eget bibendum sodales',
              image_size: '2880w',
              is_foreground: false,
              caption: 'Fusce vulputate eleifend sapien.',
              source: 'John Doe'
            },
            {
              index: 1307,
              image: 2,
              image_alt: 'Leo eget bibendum sodales',
              image_size: '2880w',
              is_foreground: false,
              caption: '',
              source: ''
            }
          ])
        ),
        get_default_data_src: gallery_src,
        get_default_data_srcset: gallery_srcset,
        copy: {
          close: 'Close overlay',
          more: 'Open more images',
          enlarged: 'View enlarged image',
          previous: 'Previous image',
          next: 'Next image'
        },
        inview: {
          threshold: 0.25,
          triggerOnce: true
        }
      },
      1: imageGalleryBlockClasses
    }
  }),
}

export const FakeCardsBlock = (initState: CMSState) =>
  cardsBlock(
    {
      blockIndex: 900,
      title: 'Press releases',
      items: List([
        {
          field_title: 'Card title',
          field_introduction: '<p>Supporting description for this card.</p>',
          field_link: { is_link_external: false, kind: 'link', target: '_self', title: 'Button', url: '/' }
        },
        {
          field_title: 'Card title',
          field_introduction: '<p>Supporting description for this card.</p>',
          field_link: { is_link_external: false, kind: 'link', target: '_self', title: 'Button', url: '/' }
        },
        {
          field_title: 'Card title',
          field_introduction: '<p>Supporting description for this card.</p>',
          field_link: { is_link_external: false, kind: 'link', target: '_self', title: 'Button', url: '/' }
        }
      ])
    },
    { style: cardsBlockClasses }
  )(initState)

export const FakeCtaBlockText = (initState: CMSState) =>
  renderBlock({
    kind: 'ctaBlock',
    value: [
      {
        index: 400,
        title: (
          <>
            Etiam rhoncus <span className="weight--bold">Maecenas tempus.</span>
          </>
        ),
        intro:
          'Leo eget bibendum sodales, augue velit cursus nunc, quis gravida magna mi a libero. Fusce vulputate eleifend sapien. Vestibulum purus quam, scelerisque ut, mollis sed, nonummy id, metus. Nullam accumsan lorem in dui.',
        buttons: 'primary_secondary',
        primary_button: {
          is_link_external: false,
          kind: 'link',
          target: '_self',
          title: 'Luctus vitae',
          url: '/'
        },
        secondary_button: {
          is_link_external: false,
          kind: 'link',
          target: '_self',
          title: 'Nullam accumsan',
          url: '/'
        },
        link_type: false,
        image: undefined,
        image_size: '640x360',
        image_alt: 'Lorem ipsum',
        display_option: 'content-width',
        get_default_data_src: get_default_data_src,
        get_default_data_srcset: get_default_data_srcset
      },
      ctaBlockClasses(false)
    ]
  })(initState)

export const FakeCtaBlockImage = (initState: CMSState) =>
  renderBlock({
    kind: 'ctaBlock',
    value: [
      {
        index: 2,
        title: (
          <>
            Etiam rhoncus <span className="weight--bold">Maecenas tempus.</span>
          </>
        ),
        intro:
          'Leo eget bibendum sodales, augue velit cursus nunc, quis gravida magna mi a libero. Fusce vulputate eleifend sapien. Vestibulum purus quam, scelerisque ut, mollis sed, nonummy id, metus. Nullam accumsan lorem in dui.',
        buttons: 'primary_secondary',
        primary_button: {
          is_link_external: false,
          kind: 'link',
          target: '_self',
          title: 'Luctus vitae',
          url: '/'
        },
        secondary_button: {
          is_link_external: false,
          kind: 'link',
          target: '_self',
          title: 'Nullam accumsan',
          url: '/'
        },
        link_type: false,
        image: 3,
        image_size: '1400w',
        image_alt: 'Lorem ipsum',
        display_option: 'full-width',
        get_default_data_src: ctablock_src,
        get_default_data_srcset: ctablock_srcset
      },
      ctaBlockClasses(true)
    ]
  })(initState)

export const FakeDownloadBlock = (initState: CMSState) =>
  renderBlock({
    kind: 'downloadBlock',
    value: [
      {
        title: (
          <>
            Etiam rhoncus <span className="weight--bold">Maecenas tempus.</span>
          </>
        ),
        intro:
          'Leo eget bibendum sodales, augue velit cursus nunc, quis gravida magna mi a libero. Fusce vulputate eleifend sapien. Vestibulum purus quam, scelerisque ut, mollis sed, nonummy id, metus. Nullam accumsan lorem in dui.',
        items: [
          {
            key: '3000',
            title: 'Circlelock Combi Product folder',
            file_url: 'pdf.pdf'
          },
          {
            key: '3001',
            title: 'Circlelock Combi Product folder',
            text: 'Subtitle of Circlelock Combi Product folder',
            file_url: 'pdf.pdf'
          }
        ],
        useSVGIcons: true,
        index: 0
      },
      downloadBlockClasses
    ]
  })(initState)

export const FakeExpandBlock = (initState: CMSState) =>
  renderBlock({
    kind: 'expandBlock',
    value: [
      {
        index: 798,
        title: (
          <>
            Etiam rhoncus <span className="weight--bold">Maecenas tempus.</span>
          </>
        ),
        intro:
          'Leo eget bibendum sodales, augue velit cursus nunc, quis gravida magna mi a libero. Fusce vulputate eleifend sapien. Vestibulum purus quam, scelerisque ut, mollis sed, nonummy id, metus. Nullam accumsan lorem in dui.',
        link: {
          kind: 'link',
          is_link_external: false,
          target: '_self',
          url: '/',
          title: 'Luctus vitae'
        },
        inview: {
          threshold: 0.1,
          triggerOnce: true
        },
        items: [
          {
            title: 'Vestibulum purus quam scelerisque ut',
            key: '1',
            index: 4,
            subtitle: 'Etiam rhoncus maecenas tempus',
            text: 'Leo eget bibendum sodales, augue velit cursus nunc, quis gravida magna mi a libero. Fusce vulputate eleifend sapien. Vestibulum purus quam, scelerisque ut, mollis sed, nonummy id, metus. Nullam accumsan lorem in dui.',
            open: false,
            useSVGIcons: true,
            blocks: List([
              {
                kind: 'mediaBlockNested',
                value: [
                  {
                    index: 900,
                    inview: {
                      threshold: 0.1,
                      triggerOnce: true
                    },
                    items: [
                      {
                        kind: 'image',
                        caption: 'Scelerisque ut, mollis sed, nonummy id, metus.',
                        source: 'Source',
                        image: 2,
                        image_alt: 'Scelerisque ut, mollis sed, nonummy id, metus.',
                        image_option: 'content-width',
                        size: '1920w',
                        get_default_data_src: get_default_data_src,
                        get_default_data_srcset: get_default_data_srcset,
                        useCookieBar: false,
                        cookieButton: GetCookiebarButton('media'),
                        cookiePlaceholder: GetCookiebarContent('media')
                      }
                    ]
                  },
                  mediaBlockNestedClasses
                ]
              }
            ])
          },
          {
            title: 'Nullam id dolor id nibh ultricies vehicula ut id elit.',
            key: '2',
            index: 5,
            subtitle: 'Etiam rhoncus maecenas tempus',
            text: 'Leo eget bibendum sodales, augue velit cursus nunc, quis gravida magna mi a libero. Fusce vulputate eleifend sapien. Vestibulum purus quam, scelerisque ut, mollis sed, nonummy id, metus. Nullam accumsan lorem in dui.',
            open: false,
            useSVGIcons: true,
            blocks: List([
              {
                kind: 'textBlockNested',
                value: [
                  {
                    index: 900,
                    inview: {
                      threshold: 0.1,
                      triggerOnce: true
                    },
                    text: '<p>Maecenas sed diam eget risus varius blandit sit amet non magna. Vestibulum id ligula porta felis euismod semper.</p> <ul><li>Bibendum Ligula Pharetra</li><li>Donec sed odio dui. Donec sed odio dui.</li></ul>'
                  },
                  textBlockNestedClasses
                ]
              }
            ])
          },
          {
            title: 'Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.',
            key: '2',
            index: 6,
            subtitle: 'Etiam rhoncus maecenas tempus',
            text: 'Leo eget bibendum sodales, augue velit cursus nunc, quis gravida magna mi a libero. Fusce vulputate eleifend sapien. Vestibulum purus quam, scelerisque ut, mollis sed, nonummy id, metus. Nullam accumsan lorem in dui.',
            open: false,
            useSVGIcons: true,
            blocks: List([
              {
                kind: 'quoteBlockNested',
                value: [
                  {
                    index: 900,
                    inview: {
                      threshold: 0.1,
                      triggerOnce: true
                    },
                    text: 'Donec sed odio dui. Sed posuere consectetur est at lobortis.',
                    author: 'John Do'
                  },
                  quoteBlockNestedClasses
                ]
              }
            ])
          }
        ]
      },
      expandBlockClasses
    ]
  })(initState)

export const FakeImageGalleryBlock = (initState: CMSState) =>
  stateful()<CMSState>((s) => renderBlock(s.blocks.get(13) as any)(s))(initState)

export const FakeLinkBlock = (initState: CMSState) =>
  renderBlock({
    kind: 'linkBlock',
    value: [
      {
        title: (
          <>
            Etiam rhoncus <span className="weight--bold">Maecenas tempus.</span>
          </>
        ),
        index: 5000,
        useSVGIcons: false,
        intro:
          'Leo eget bibendum sodales, augue velit cursus nunc, quis gravida magna mi a libero. Fusce vulputate eleifend sapien. Vestibulum purus quam, scelerisque ut, mollis sed, nonummy id, metus. Nullam accumsan lorem in dui.',
        items: [
          {
            key: '1902-1',
            title: 'Leo eget bibendum sodales',
            url: '/',
            target: '_self',
            is_link_external: true
          },
          {
            key: '1902-2',
            title: 'Augue velit cursus nunc',
            url: '/',
            target: '_blank',
            is_link_external: true
          },
          {
            key: '1902-3',
            title: 'Quis gravida magna',
            text: 'Augue velit cursus nunc',
            url: '/',
            target: '_self',
            is_link_external: true
          },
          {
            key: '1902-4',
            title: 'Mi a libero',
            text: 'Augue velit cursus nunc',
            url: '/',
            target: '_self',
            is_link_external: true
          }
        ]
      },
      linkListBlockClasses
    ]
  })(initState)

export const FakeLinkGridTextBlock = (initState: CMSState) =>
  renderBlock({
    kind: 'linkGridBlock',
    value: [
      {
        index: 800,
        title: (
          <>
            Etiam rhoncus <span className="weight--bold">Maecenas tempus.</span>
          </>
        ),
        intro:
          'Leo eget bibendum sodales, augue velit cursus nunc, quis gravida magna mi a libero. Fusce vulputate eleifend sapien. Vestibulum purus quam, scelerisque ut, mollis sed, nonummy id, metus. Nullam accumsan lorem in dui.',
        items: [
          {
            image: 2,
            image_size: '640x360',
            image_alt: '',
            title: 'Donec vitae',
            label: 'Lorem ipsum',
            intro:
              'Fusce dapibus, tellus ac cursus commodo, tortor mauris condimentum nibh, ut fermentum massa justo sit amet risus. Cras mattis consectetur purus sit amet fermentum.',
            show_image: 'no'
          },
          {
            image: 2,
            image_size: '640x360',
            image_alt: '',
            title: 'Donec vitae Pharetra Nibh Cursus Quam Condimentum',
            label: 'Lorem ipsum',
            intro: 'Consectetuer adipiscing elit.',
            link: {
              is_link_external: false,
              kind: 'link',
              target: '_self',
              title: 'Luctus vitae',
              url: '/'
            },
            show_image: 'no'
          },
          {
            image: 2,
            image_size: '640x360',
            image_alt: '',
            title: 'Donec vitae',
            label: 'Lorem ipsum',
            intro: 'Consectetuer adipiscing elit. Morbi leo risus, porta ac consectetur ac, vestibulum at eros.',
            link: {
              is_link_external: false,
              kind: 'link',
              target: '_self',
              title: 'Luctus vitae',
              url: ''
            },
            show_image: 'no'
          },
          {
            image: 2,
            image_size: '640x360',
            image_alt: '',
            title: 'Donec vitae',
            intro: 'Consectetuer adipiscing elit.',
            link: {
              is_link_external: false,
              kind: 'link',
              target: '_self',
              title: 'Luctus vitae',
              url: '/'
            },
            show_image: 'no'
          },
          {
            image: 2,
            image_size: '640x360',
            image_alt: '',
            title: 'Donec vitae',
            intro: 'Consectetuer adipiscing elit.',
            link: {
              is_link_external: false,
              kind: 'link',
              target: '_self',
              title: 'Luctus vitae',
              url: ''
            },
            show_image: 'no'
          },
          {
            image: 2,
            image_size: '640x360',
            image_alt: '',
            title: 'Donec vitae',
            intro: 'Consectetuer adipiscing elit.',
            link: {
              is_link_external: false,
              kind: 'link',
              target: '_self',
              title: 'Luctus vitae',
              url: '/'
            },
            show_image: 'no'
          }
        ],
        link: {
          is_link_external: false,
          kind: 'link',
          target: '_self',
          title: 'Luctus vitae',
          url: '/'
        },
        show_image: 'no',
        get_default_data_src: linkgridblock_src,
        get_default_data_srcset: linkgridblock_srcset
      },
      linkGridBlockPlainClasses
    ]
  })(initState)

export const FakeLinkGridTextImageBlock = (initState: CMSState) =>
  renderBlock({
    kind: 'linkGridBlock',
    value: [
      {
        index: 801,
        title: (
          <>
            Etiam rhoncus <span className="weight--bold">Maecenas tempus.</span>
          </>
        ),
        intro:
          'Leo eget bibendum sodales, augue velit cursus nunc, quis gravida magna mi a libero. Fusce vulputate eleifend sapien. Vestibulum purus quam, scelerisque ut, mollis sed, nonummy id, metus. Nullam accumsan lorem in dui.',
        items: [
          {
            image: 2,
            image_size: '640x360',
            image_alt: '',
            title: 'Donec vitae  Parturient Egestas Fusce Ridiculus Vehicula',
            label: 'Lorem ipsum',
            intro: 'Consectetuer adipiscing elit.',
            show_image: 'yes'
          },
          {
            image: 2,
            image_size: '640x360',
            image_alt: '',
            title: 'Donec vitae',
            label: 'Lorem ipsum',
            intro:
              'Consectetuer adipiscing elit. Curabitur blandit tempus porttitor. Aenean lacinia bibendum nulla sed consectetur.',
            link: {
              is_link_external: false,
              kind: 'link',
              target: '_self',
              title: 'Luctus vitae',
              url: '/'
            },
            show_image: 'yes'
          },
          {
            image: 2,
            image_size: '640x360',
            image_alt: '',
            title: 'Etiam porta sem malesuada magna mollis euismod.',
            label: 'Lorem ipsum',
            intro:
              'Consectetuer adipiscing elit. Nulla vitae elit libero, a pharetra augue. Aenean lacinia bibendum nulla sed consectetur.',
            link: {
              is_link_external: false,
              kind: 'link',
              target: '_self',
              title: 'Luctus vitae',
              url: ''
            },
            show_image: 'yes'
          },
          {
            image: 2,
            image_size: '640x360',
            image_alt: '',
            title: 'Donec vitae',
            intro: 'Consectetuer adipiscing elit.',
            link: {
              is_link_external: false,
              kind: 'link',
              target: '_self',
              title: 'Luctus vitae',
              url: '/'
            },
            show_image: 'yes'
          },
          {
            image: 2,
            image_size: '640x360',
            image_alt: '',
            title: 'Donec vitae',
            intro: 'Consectetuer adipiscing elit.',
            link: {
              is_link_external: false,
              kind: 'link',
              target: '_self',
              title: 'Luctus vitae',
              url: ''
            },
            show_image: 'yes'
          },
          {
            image: 2,
            image_size: '640x360',
            image_alt: '',
            title: 'Donec vitae',
            intro: 'Consectetuer adipiscing elit.',
            link: {
              is_link_external: false,
              kind: 'link',
              target: '_self',
              title: 'Luctus vitae',
              url: '/'
            },
            show_image: 'yes'
          }
        ],
        link: {
          is_link_external: false,
          kind: 'link',
          target: '_self',
          title: 'Luctus vitae',
          url: '/'
        },
        show_image: 'yes',
        get_default_data_src: get_default_data_src,
        get_default_data_srcset: get_default_data_srcset
      },
      linkGridBlockClasses
    ]
  })(initState)

// The plain variant renders the image full width across the top of the card,
// as opposed to the circular visual of `linkGridBlockClasses`.
export const FakeLinkGridTextImageWideBlock = (initState: CMSState) =>
  renderBlock({
    kind: 'linkGridBlock',
    value: [
      {
        index: 803,
        title: (
          <>
            Etiam rhoncus <span className="weight--bold">Maecenas tempus.</span>
          </>
        ),
        intro:
          'Leo eget bibendum sodales, augue velit cursus nunc, quis gravida magna mi a libero. Fusce vulputate eleifend sapien.',
        items: [
          {
            image: 2,
            image_size: '640x360',
            image_alt: '',
            title: 'Donec vitae Parturient Egestas Fusce Ridiculus Vehicula',
            label: 'Lorem ipsum',
            intro: 'Consectetuer adipiscing elit.',
            link: {
              is_link_external: false,
              kind: 'link',
              target: '_self',
              title: 'Luctus vitae',
              url: '/'
            },
            show_image: 'yes'
          },
          {
            image: 2,
            image_size: '640x360',
            image_alt: '',
            title: 'Donec vitae',
            label: 'Lorem ipsum',
            intro: 'Consectetuer adipiscing elit. Curabitur blandit tempus porttitor. Aenean lacinia bibendum nulla sed consectetur.',
            link: {
              is_link_external: false,
              kind: 'link',
              target: '_self',
              title: 'Luctus vitae',
              url: '/'
            },
            show_image: 'yes'
          },
          {
            image: 2,
            image_size: '640x360',
            image_alt: '',
            title: 'Etiam porta sem malesuada magna mollis euismod.',
            label: 'Lorem ipsum',
            intro: 'Consectetuer adipiscing elit. Nulla vitae elit libero, a pharetra augue.',
            link: {
              is_link_external: false,
              kind: 'link',
              target: '_self',
              title: 'Luctus vitae',
              url: '/'
            },
            show_image: 'yes'
          }
        ],
        link: {
          is_link_external: false,
          kind: 'link',
          target: '_self',
          title: 'Luctus vitae',
          url: '/'
        },
        show_image: 'yes',
        get_default_data_src: get_default_data_src,
        get_default_data_srcset: get_default_data_srcset
      },
      linkGridBlockPlainClasses
    ]
  })(initState)

export const FakeLinkGridImageBlock = (initState: CMSState) =>
  renderBlock({
    kind: 'linkGridBlock',
    value: [
      {
        index: 802,
        title: (
          <>
            Etiam rhoncus <span className="weight--bold">Maecenas tempus.</span>
          </>
        ),
        items: [
          {
            image: 2,
            image_size: '640x360',
            image_alt: '',
            title: '',
            label: '',
            intro: '',
            link: {
              is_link_external: false,
              kind: 'link',
              target: '_self',
              title: '',
              url: ''
            },
            show_image: 'yes'
          },
          {
            image: 2,
            image_size: '640x360',
            image_alt: '',
            title: '',
            label: '',
            intro: '',
            link: {
              is_link_external: false,
              kind: 'link',
              target: '_self',
              title: '',
              url: ''
            },
            show_image: 'yes'
          },
          {
            image: 2,
            image_size: '640x360',
            image_alt: '',
            title: '',
            label: '',
            intro: '',
            link: {
              is_link_external: false,
              kind: 'link',
              target: '_self',
              title: '',
              url: ''
            },
            show_image: 'yes'
          }
        ],
        show_image: 'yes',
        get_default_data_src: get_default_data_src,
        get_default_data_srcset: get_default_data_srcset
      },
      linkGridBlockClasses
    ]
  })(initState)

export const FakeMediaBlockImages = (initState: CMSState) =>
  any([
    renderBlock(
      {
        kind: 'mediaBlock',
        value: [
          {
            index: 900,
            title: (
              <>
                Etiam rhoncus <span className="weight--bold">Maecenas tempus.</span>
              </>
            ),
            intro:
              'Leo eget bibendum sodales, augue velit cursus nunc, quis gravida magna mi a libero. Fusce vulputate eleifend sapien. Vestibulum purus quam, scelerisque ut, mollis sed, nonummy id, metus. Nullam accumsan lorem in dui.',
            items: [
              {
                caption: 'Content-width vestibulum purus quam, scelerisque ut, mollis sed, nonummy id, metus.',
                source: 'Source',
                image: 2,
                image_alt: 'Content-width vestibulum purus quam, scelerisque ut, mollis sed, nonummy id, metus.',
                image_option: 'content-width',
                size: '640w',
                kind_media: 'image',
                video: {
                  allowFullScreen: true,
                  frameBorder: '0',
                  height: '315',
                  width: '420',
                  url: 'https://www.youtube.com/watch?v=GlhzdGx4ldE',
                  id: '200',
                  type: 'video'
                },
                get_default_data_src: get_default_data_src,
                get_default_data_srcset: get_default_data_srcset,
                useCookieBar: false,
                cookieButton: GetCookiebarButton('media'),
                cookiePlaceholder: GetCookiebarContent('media')
              },
              {
                caption: 'Full-width vestibulum purus quam, scelerisque ut, mollis sed, nonummy id, metus.',
                source: 'Source',
                image: 2,
                image_alt: 'Full-width vestibulum purus quam, scelerisque ut, mollis sed, nonummy id, metus.',
                image_option: 'full-width',
                size: '1920w',
                kind_media: 'image',
                video: {
                  allowFullScreen: true,
                  frameBorder: '0',
                  height: '315',
                  width: '420',
                  url: 'https://www.youtube.com/watch?v=GlhzdGx4ldE',
                  id: '200',
                  type: 'video'
                },
                get_default_data_src: get_default_data_src,
                get_default_data_srcset: get_default_data_srcset,
                useCookieBar: false,
                cookieButton: GetCookiebarButton('media'),
                cookiePlaceholder: GetCookiebarContent('media')
              }
            ]
          },
          mediaBlockClasses
        ]
      }
    )(initState),
    renderBlock(
      {
        kind: 'mediaBlock',
        value: [
          {
            index: 901,
            items: [
              {
                caption: 'Content-width vestibulum purus quam, scelerisque ut, mollis sed, nonummy id, metus.',
                source: 'Source',
                image: 2,
                image_alt: 'Content-width vestibulum purus quam, scelerisque ut, mollis sed, nonummy id, metus.',
                image_option: 'content-width',
                size: '1920w',
                kind_media: 'video',
                video: {
                  allowFullScreen: true,
                  frameBorder: '0',
                  height: '315',
                  width: '420',
                  url: 'https://www.youtube.com/watch?v=GlhzdGx4ldE',
                  id: '200',
                  type: 'video'
                },
                get_default_data_src: get_default_data_src,
                get_default_data_srcset: get_default_data_srcset,
                useCookieBar: false,
                cookieButton: GetCookiebarButton('media'),
                cookiePlaceholder: GetCookiebarContent('media')
              },
              {
                caption: 'Full-width vestibulum purus quam, scelerisque ut, mollis sed, nonummy id, metus.',
                source: 'Source',
                image: 2,
                image_alt: 'Full-width vestibulum purus quam, scelerisque ut, mollis sed, nonummy id, metus.',
                image_option: 'full-width',
                size: '1920w',
                kind_media: 'video',
                video: {
                  allowFullScreen: true,
                  frameBorder: '0',
                  height: '315',
                  width: '420',
                  url: 'https://www.youtube.com/watch?v=GlhzdGx4ldE',
                  id: '200',
                  type: 'video'
                },
                get_default_data_src: get_default_data_src,
                get_default_data_srcset: get_default_data_srcset,
                useCookieBar: true,
                cookieButton: GetCookiebarButton('media'),
                cookiePlaceholder: GetCookiebarContent('media')
              }
            ]
          },
          mediaBlockClasses
        ]
      }
    )(initState)
  ])

export const FakeTextBlock = (initState: CMSState) =>
  renderBlock({
    kind: 'textBlock',
    value: [
      {
        title: (
          <>
            Etiam rhoncus <span className="weight--bold">Maecenas tempus.</span>
          </>
        ),
        text: `
            <p><b>Tellus eget condimentum rhoncus, <a href='/'>sem quam semper libero</a>, sit amet
            adipiscing sem neque sed ipsum. Nam quam nunc, blandit vel, luctus pulvinar, hendrerit id, lorem.
            Maecenas nec odio et ante <em>tincidunt tempus</em>. Donec vitae sapien ut libero venenatis faucibus.
            Nullam quis ante. Etiam sit amet orci eget eros faucibus tincidunt.</b></p>
            <h3>Vestibulum ante itae sapien ut libero</h3>
            <p>Leo eget bibendum sodales, augue velit cursus nunc, quis gravida magna mi a libero. Fusce vulputate eleifend sapien. Vestibulum purus quam, scelerisque ut, mollis sed, nonummy id, metus. Nullam accumsan lorem in dui.
            Cras ultricies mi eu turpis hendrerit fringilla.</p>
            <ul>
              <li>Morbi leo risus, porta ac consectetur ac, vestibulum at eros.</li>
              <li>Aenean lacinia bibendum nulla sed consectetur.</li>
              <li>Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.
                <ul>
                  <li>Integer consequat sapien a lectus gravida euismod.</li>
                  <li>Integer consequat sapien a lectus gravida euismod.</li>
                </ul>
              </li>
              <li>Nullam quis risus eget urna mollis ornare vel eu leo.</li>
            </ul>
            <h4>A pharetra augue itae sapien ut libero venenatis</h4>
            <p>Consectetuer adipiscing elit. Integer consequat sapien a lectus gravida euismod. Sed vitae nisl non odio viverra accumsan. Curabitur nisi neque, egestas sed, vulputate sit amet, luctus vitae, dolor. Cras lacus massa, sagittis ut, volutpat consequat, interdum a, nulla</p>
            <ol>
              <li>Morbi leo risus, porta ac consectetur ac, vestibulum at eros.</li>
              <li>Aenean lacinia bibendum nulla sed consectetur.</li>
              <li>Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.
                <ol>
                  <li>Morbi leo risus, porta ac consectetur ac, vestibulum at eros.</li>
                  <li>Aenean lacinia bibendum nulla sed consectetur.</li>
                </ol>
              </li>
              <li>Nullam quis risus eget urna mollis ornare vel eu leo.</li>
            </ol>
            <h5>Tincidunt tempus itae sapien ut</h5>
            <p>Etiam rhoncus. Maecenas tempus, tellus eget condimentum rhoncus, <a href='/'>sem quam semper libero</a>, sit <b>amet</b> adipiscing sem neque sed ipsum. Nam quam nunc, blandit vel, luctus pulvinar, hendrerit id, lorem.
            Maecenas nec odio et ante <em>tincidunt tempus</em>.</p>
            <h6>Hendrerit fringilla quis risus eget urna mollis ornare vel</h6>
            <p>Leo eget bibendum sodales, augue velit cursus nunc, quis gravida magna mi a libero. Fusce vulputate eleifend sapien. Vestibulum purus quam, scelerisque ut, mollis sed, nonummy id, metus. Nullam accumsan lorem in dui. Cras ultricies mi eu turpis hendrerit fringilla. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; In ac dui quis mi consectetuer lacinia.</p>
          `,
        primary_button: {
          is_link_external: false,
          kind: 'link',
          target: '_self',
          title: 'Luctus vitae',
          url: '/'
        },
        link: {
          is_link_external: false,
          kind: 'link',
          target: '_self',
          title: 'Donec vitae',
          url: '/'
        },
        link_type: false,
        index: 0
      },
      textBlockClasses
    ]
  })(initState)

// Mirrors the site, which renders this block as a custom block:
// `textImageBlock` -> `FeaturedContentBlock`.
const fakeTextImage = (alignImage: 'left' | 'right') =>
  fromJSX(() => (
    <FeaturedContentBlock
      isStyleguide={true}
      alignImage={alignImage}
      title="Etiam rhoncus Maecenas tempus."
      intro="Nullam quis risus eget urna mollis ornare vel eu leo. Aenean eu leo quam. Pellentesque ornare sem lacinia quam venenatis vestibulum."
      imageStyleguide={{
        src: '/styleguide/images/1920x1080.png',
        srcSet: '/styleguide/images/1920x1080.png 1920w',
        alt: ''
      }}
      button={{ text: 'Luctus vitae', url: '/' }}
      secondaryButtonStyleguide={{ text: 'Quam Dapibus uam Dapibus', url: '/' }}
    />
  ))

export const FakeTextImageLeftBlock = (_initState: CMSState) => fakeTextImage('left')

export const FakeTextImageRightBlock = (_initState: CMSState) => fakeTextImage('right')

export const FakeQuoteBlockPerson = (initState: CMSState) =>
  quoteBlock({
    blockIndex: 901,
    quote:
      'When it comes to the drinks we produce, we look beyond the label and see our people, our solutions and our innovations.',
    person: 'First name Last name',
    function: 'Job title',
    background: 'white',
    primaryButton: { kind: 'link', is_link_external: false, target: '_self', url: '/', title: 'Button' },
    secondaryButton: { kind: 'link', is_link_external: false, target: '_self', url: '/', title: 'Button' }
  })(initState)

export const FakeQuoteBlockText = (initState: CMSState) =>
  renderBlock({
    kind: 'quoteBlock',
    value: [
      {
        index: 5,
        text: 'Consectetuer adipiscing elit. Integer consequat sapien a lectus gravida euismod. Sed vitae nisl non odio viverra accumsan.',
        author: 'Etiam rhoncus. Maecenas tempus...',
        link: {
          kind: 'link',
          is_link_external: false,
          target: '_self',
          url: '#',
          title: 'Luctus vitae'
        },
        image: 2,
        image_alt: '',
        image_size: '640x360',
        get_default_data_src: quoteblock_src,
        get_default_data_srcset: quoteblock_srcset
      },
      quoteBlockClasses(false)
    ]
  })(initState)

export const FakeQuoteBlockTextImage = (initState: CMSState) =>
  renderBlock({
    kind: 'quoteBlock',
    value: [
      {
        index: 5,
        text: 'Consectetuer adipiscing elit. Integer consequat sapien a lectus gravida euismod. Sed vitae nisl non odio viverra accumsan.',
        author: 'Etiam rhoncus. Maecenas tempus...',
        image: 2,
        image_alt: '',
        image_size: '640x360',
        get_default_data_src: quoteblock_src,
        get_default_data_srcset: quoteblock_srcset
      },
      quoteBlockClasses(true)
    ]
  })(initState)

export const FakeTimelineLeftBlock = (initState: CMSState) => (
  <li className="block__item item">
    <div className="item__inner">
      <div className="item__content">
        <header className="item__header">
          <h3 className="item__title title--m">year X</h3>
        </header>
        <div className="item__text">
          <div className="item__intro">
            Maecenas faucibus mollis interdum. Vestibulum id ligula porta felis euismod semper. Cum sociis natoque
            penatibus et magnis dis parturient montes, nascetur ridiculus mus. Integer posuere erat a ante venenatis
            dapibus posuere velit aliquet. Nullam quis risus eget urna mollis ornare vel eu leo. Donec sed odio dui.
          </div>
        </div>
      </div>
      <div className="item__visual">
        <img
          src="/styleguide/images/640x360.png"
          data-src="/styleguide/images/640x360.png"
          data-srcset="/styleguide/images/640x360.png 640w,/styleguide/images/1280x720.png 1280w,/styleguide/images/1920x1080.png 1920w,/styleguide/images/2880x1620.png 2880w"
          data-sizes="auto"
          className="item__image"
          alt=""
        />
      </div>
    </div>
  </li>
)

export const FakeTimelineRightBlock = (initState: CMSState) => (
  <li className="block__item item item--right">
    <div className="item__inner">
      <div className="item__content">
        <header className="item__header">
          <h3 className="item__title title--m">year Y</h3>
        </header>
        <div className="item__text">
          <div className="item__intro">
            Maecenas faucibus mollis interdum. Vestibulum id ligula porta felis euismod semper. Cum sociis natoque
            penatibus et magnis dis parturient montes, nascetur ridiculus mus. Integer posuere erat a ante venenatis
            dapibus posuere velit aliquet. Nullam quis risus eget urna mollis ornare vel eu leo. Donec sed odio dui.
          </div>
        </div>
      </div>
      <div className="item__visual">
        <img
          src="/styleguide/images/640x360.png"
          data-src="/styleguide/images/640x360.png"
          data-srcset="/styleguide/images/640x360.png 640w,/styleguide/images/1280x720.png 1280w,/styleguide/images/1920x1080.png 1920w,/styleguide/images/2880x1620.png 2880w"
          data-sizes="auto"
          className="item__image"
          alt=""
        />
      </div>
    </div>
  </li>
)

export const FakeStoriesBlock = (initState: CMSState) => (
  <>
    <li className="grid__item">
      <article className="grid__article">
        <a className="grid__link" href="#">
          <div className="grid__content">
            <header className="grid__header">
              <span className="grid__label block__label label--m">06 august 2019</span>
              <h3 className="grid__title title--xs">Donec vitae Parturient Egestas Fusce Ridiculus Vehicula</h3>
            </header>
            <span className="grid__fauxlink link link--arrow">Luctus vitae</span>
          </div>
          <div className="grid__visual container fit-object">
            <img
              src="/styleguide/images/640x360.png"
              data-srcset=""
              data-sizes="auto"
              className="grid__image lazyautosizes lazyloaded"
              alt=""
              sizes="420px"
            />
          </div>
        </a>
      </article>
    </li>
    <li className="grid__item">
      <article className="grid__article">
        <div className="grid__link">
          <div className="grid__content">
            <header className="grid__header">
              <span className="grid__label block__label label--m">06 august 2019</span>
              <h3 className="grid__title title--xs">Maecenas faucibus mollis interdum</h3>
            </header>
          </div>
          <div className="grid__visual container fit-object">
            <img
              src="/styleguide/images/640x360.png"
              data-srcset=""
              data-sizes="auto"
              className="grid__image lazyautosizes lazyloaded"
              alt=""
              sizes="420px"
            />
          </div>
        </div>
      </article>
    </li>
    <li className="grid__item">
      <article className="grid__article">
        <a className="grid__link" href="#">
          <div className="grid__content">
            <header className="grid__header">
              <span className="grid__label block__label label--m">06 august 2019</span>
              <h3 className="grid__title title--xs">
                Nullam id dolor id nibh ultricies vehicula ut id elit. Donec ullamcorper nulla non metus auctor
                fringilla
              </h3>
            </header>
            <span className="grid__fauxlink link link--arrow">Luctus vitae</span>
          </div>
          <div className="grid__visual container fit-object">
            <img
              src="/styleguide/images/640x360.png"
              data-srcset=""
              data-sizes="auto"
              className="grid__image lazyautosizes lazyloaded"
              alt=""
              sizes="420px"
            />
          </div>
        </a>
      </article>
    </li>
  </>
)

export const FakePressReleaseBlock = (initState: CMSState) => (
  <>
    <li className="grid__item">
      <article className="grid__article">
        <a className="grid__link" href="#">
          <div className="grid__content">
            <header className="grid__header">
              <span className="grid__label block__label label--m">07 august 2019</span>
              <h3 className="grid__title title--xs">Donec vitae Parturient Egestas Fusce Ridiculus Vehicula</h3>
            </header>
            <span className="grid__fauxlink link">Luctus vitae</span>
          </div>
        </a>
      </article>
    </li>
    <li className="grid__item">
      <article className="grid__article">
        <div className="grid__link">
          <div className="grid__content">
            <header className="grid__header">
              <span className="grid__label block__label label--m">08 august 2019</span>
              <h3 className="grid__title title--xs">Maecenas faucibus mollis interdum</h3>
            </header>
          </div>
        </div>
      </article>
    </li>
    <li className="grid__item">
      <article className="grid__article">
        <a className="grid__link" href="#">
          <div className="grid__content">
            <header className="grid__header">
              <span className="grid__label block__label label--m">09 august 2019</span>
              <h3 className="grid__title title--xs">
                Nullam id dolor id nibh ultricies vehicula ut id elit. Donec ullamcorper nulla non metus auctor
                fringilla
              </h3>
            </header>
            <span className="grid__fauxlink link">Luctus vitae</span>
          </div>
        </a>
      </article>
    </li>
  </>
)
